import { render } from "./VendorsFeesCreateForm.vue?vue&type=template&id=74d4dd77"
import script from "./VendorsFeesCreateForm.vue?vue&type=script&lang=js"
export * from "./VendorsFeesCreateForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__